import Resource from "../Entity/Resource";
import CreateDownload from "./CreateDownload";
import CreateDownloadRequest from "./Request/CreateDownloadRequest";
import Document from "../Entity/Document";
import DownloadManager from "../Entity/DownloadManager";
import DocumentResource from "../Entity/DocumentResource";
import DownloadType from "../ValueObject/DownloadType";
import Status from "../ValueObject/Status";
import CreateDownloadFromResourceRequest from "./Request/CreateDownloadFromResourceRequest";
import DocumentDownload from "../Entity/DocumentDownload";
import DocumentDownloadFactory from "../Factory/DocumentDownloadFactory";

export default class CreateDownloadFromResource {
    public constructor(
        private readonly createDownload: CreateDownload,
        private readonly documentDownloadFactory: DocumentDownloadFactory
    ) {
    }

    public create(request: CreateDownloadFromResourceRequest): DocumentDownload[] {
        const resource: Resource = request.getResource();
        const pendingDownloads: DocumentDownload[] = [];
        for (const document of this.getDocumentDownloadUrl(request)) {
            const documentDownload: DocumentDownload = this.documentDownloadFactory.create(
                resource.getId(),
                document,
                request.getSessionToken()
            );

            pendingDownloads.push(documentDownload);
        }

        return pendingDownloads;
    }

    private getDocumentDownloadUrl(request: CreateDownloadFromResourceRequest): Document[] {
        return this.createDownload.create(
            this.request(request)
        );
    }

    private request(request: CreateDownloadFromResourceRequest): CreateDownloadRequest {
        const resource: Resource = request.getResource();
        const documents: Document[] = request.getDocuments();

        return new CreateDownloadRequest(
            resource,
            this.createDownloadManager(resource),
            this.createDocumentResources(resource, documents),
            documents,
        );
    }

    private createDownloadManager(resource: Resource): DownloadManager {
        return new DownloadManager(
            resource.getId(),
            resource.getName(),
            DownloadType.RESOURCE,
            Status.PENDING
        );
    }

    private createDocumentResources(
        resource: Resource,
        documents: Document[]
    ): DocumentResource[] {
        return documents.map(document => new DocumentResource(
            resource.getId() + '-' + document.getId(),
            resource.getId(),
            document.getIdInteger()
        ));
    }
}